export default () => ({
  booking: null,
  bookingList: [],
});
